export const GRID = 16
export const OFFSET = 4
export const PADDING = 8
export const UNIT = 16
export const DRAG_WIDTH = 20
export const CANVAS_WIDTH = 76 * UNIT
export const CANVAS_HEIGHT = 80 * UNIT
export const BORDER_WIDTH = 1
export const CARD_WIDTH = 10 * UNIT

export const SMALL_TEXT = 0.6875 * UNIT

export const LINE_HEIGHT = 1.5

export const WEBSITE_MARGIN = 0.125 * UNIT
